import Store from "@/store";
import { setStoreState } from "../../utils";
import i18n from "@/i18n";
import { persistLocale } from "@/utils/locale";
import { applyTdk } from "@/utils/tdk";

import { getToken, removeToken } from "@/utils/auth";
import { state } from "./state";
const userActions = {
  async get(): Promise<any> {
    try {
      // setStoreState('user', 'user', res)
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },
  async setUserInfo(context, user): Promise<any> {
    try {
      console.log("user", user);
      const locale = user.country_code == "86" ? "zh-CN" : "zh-TW";
      setStoreState("user", "user", user);
      // if(!state.language) {
      window.localStorage.setItem("language", locale);
      window.localStorage.setItem("platform", locale);
      setStoreState("user", "platform", locale);
      setStoreState("user", "language", locale);
      setStoreState("user", "token", user.token);
      i18n.global.locale = locale;
      persistLocale(locale);
      applyTdk(locale);
      // }
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },
  async setLang(context, lang): Promise<any> {
    try {
      console.log("lang", lang);
      setStoreState("user", "lang", lang);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },
  async setToken(context, token): Promise<any> {
    try {
      setStoreState("user", "token", token);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },
  async setLoginShow(context, showLogin): Promise<any> {
    try {
      setStoreState("user", "showLogin", showLogin);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },

  async setRemoveToken(): Promise<any> {
    try {
      setStoreState("user", "showLogin", false);
      setStoreState("user", "token", "");
      setStoreState("user", "user", {});
      removeToken();
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },

  async setExchangeRate(context, exchangeRate): Promise<any> {
    try {
      setStoreState("user", "exchangeRate", exchangeRate);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },

  async setPlatform(context, platform): Promise<any> {
    try {
      state.platform = platform;
      window.localStorage.setItem("platform", platform);
      // setStoreState('user', 'exchangeRate', platform === 'zh-CN' ? '0.0507' : '0.2135')
      setStoreState("user", "platform", platform);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },

  /**
   *
   * @param context
   * @param language  zh-CN 中文 zh-TW 繁体
   */
  async setLanguage(context, language): Promise<any> {
    try {
      i18n.global.locale = language;
      window.localStorage.setItem("language", language);
      state.language = language;
      setStoreState("user", "language", language);
      persistLocale(language);
      applyTdk(language);
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  },
  async setShowPaymentDialog(context, v): Promise<any> {
    try {
      setStoreState("user", "showPaymentDialog", v);
    } catch (error: any) {
      throw error;
    }
  },
};

type UserActionsType = typeof userActions;

export { UserActionsType };
export default userActions;
